<div class="notifications-container">
  <button
    class="notification-btn"
    (click)="toggle($event)"
    [class.active]="isOpen"
    matTooltip="Notificações"
  >
    <mat-icon>notifications</mat-icon>
    @if (notificationService.unreadCount() > 0) {
      <span class="notification-badge">
        {{ notificationService.unreadCount() > 99 ? '99+' : notificationService.unreadCount() }}
      </span>
    }
  </button>

  @if (isOpen) {
    <div class="notifications-panel">
      <div class="notifications-header">
        <span class="notifications-title">Notificações</span>
        <div class="notifications-status">
          <span class="status-dot" [class.connected]="notificationService.isConnected()"></span>
          <span class="status-label">{{
            notificationService.isConnected() ? 'Conectado' : 'Desconectado'
          }}</span>
        </div>
      </div>

      <div class="notifications-tabs">
        <button class="tab-btn" [class.active]="tab === 'all'" (click)="tab = 'all'">
          Todas
          @if (notificationService.notifications().length > 0) {
            <span class="tab-count">{{ notificationService.notifications().length }}</span>
          }
        </button>
        <button class="tab-btn" [class.active]="tab === 'unread'" (click)="tab = 'unread'">
          Não lidas
          @if (notificationService.unreadCount() > 0) {
            <span class="tab-count unread">{{ notificationService.unreadCount() }}</span>
          }
        </button>
        <button class="tab-btn" [class.active]="tab === 'read'" (click)="tab = 'read'">
          Lidas
        </button>
      </div>

      @if (filtered.length === 0) {
        <div class="notifications-empty">
          <mat-icon>notifications_none</mat-icon>
          <span>Nenhuma notificação</span>
        </div>
      } @else {
        <div class="notifications-list">
          @for (n of filtered; track n.notificationId) {
            <div
              class="notification-item"
              [ngClass]="{
                unread: !n.isRead,
                'type-info': n.type === 'info',
                'type-success': n.type === 'success',
                'type-warning': n.type === 'warning',
                'type-error': n.type === 'error',
              }"
              (click)="notificationService.markAsRead([n.notificationId])"
              [matTooltip]="n.isRead ? 'Marcar como não lida' : 'Marcar como lida'"
            >
              <span class="unread-dot" [class.visible]="!n.isRead"></span>
              <div class="notification-icon">
                <mat-icon>{{
                  n.type === 'success'
                    ? 'check_circle'
                    : n.type === 'error'
                      ? 'error'
                      : n.type === 'warning'
                        ? 'warning'
                        : 'info'
                }}</mat-icon>
              </div>
              <div class="notification-content">
                <span class="notification-title">{{ n.title }}</span>
                <span class="notification-message">{{ n.message }}</span>
                <span class="notification-time">{{ n.createdAtUtc | date: 'dd/MM HH:mm' }}</span>
              </div>
            </div>
          }
        </div>
        <div class="notifications-footer">
          @if (notificationService.unreadCount() > 0) {
            <button
              class="mark-all-btn"
              (click)="markAllAsRead()"
            >
              Marcar todas como lidas
            </button>
          }
        </div>
      }
    </div>
  }
</div>
